"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileEvents = exports.FileCommands = exports.FileEventTopic = void 0;
exports.FileEventTopic = "file.fct.event.v1";
var FileCommands;
(function (FileCommands) {
    FileCommands["CommandRequested"] = "file.cmd.requested.v1";
    FileCommands["CommandCompleted"] = "file.cmd.completed.v1";
})(FileCommands || (exports.FileCommands = FileCommands = {}));
var FileEvents;
(function (FileEvents) {
    FileEvents["Uploaded"] = "Uploaded";
    FileEvents["UploadFailed"] = "UploadFailed";
    FileEvents["OcrAnalysisCompleted"] = "OcrAnalysisCompleted";
})(FileEvents || (exports.FileEvents = FileEvents = {}));
//# sourceMappingURL=FileEvents.js.map